import { css } from '@emotion/core'
import React from 'react'

import { breakpoints } from '../constants/breakPoints'
import { HubspotForm } from './HubspotForm'

export const ProductDigestSignup = () => {
  return (
    <div css={containerStyle}>
      <h2 className="heading2 center blue-mesh-text no-margin">
        A curated bi-weekly roundup of <br className="hide-on-small-medium hide-on-desktop" /> learnings
        <br className="hide-on-small-medium-large" /> to build better products
      </h2>
      <div className="subtitle center">
        It's hard to cut through the clutter of PM Content. We select top stories about tactics,
        <br className="hide-on-small-medium" /> tools and innovations from product management thought-leaders. Level-up
        in <br className="hide-on-small-medium" /> 5 minutes, once every two weeks on this page or get it sent to your
        inbox.
      </div>
      <HubspotForm blackBG isCentered submitOnRight hubspotFormId="afc63de9-b452-4473-b3c3-f1f8df035204" />
    </div>
  )
}

const containerStyle = css`
  @media screen and (max-width: ${breakpoints.small}px) {
    .subtitle,
    .legal-consent-container > div > p {
      text-align: left !important;
    }

    .actions > input {
      width: 100%;
    }
  }
`
